import * as types from '../types/eventOverviewTypes';

export const changeFileUploadingStatus = (status=false)=>{
  return ({
    type: types.CHANGE_STATUS_OF_UPLOADING,
    payload: status
  })
}